export const lcSideFilterStandard = {
  name: 'Category Page Filters',
  filtersCollection: {
    items: [
      {
        name: 'contentType',
        displayName: 'Content Type',
        filtersCollection: {
          items: [
            {
              name: 'articles',
              displayName: 'Articles',
            },
            {
              name: 'guides',
              displayName: 'Guides',
            },
            {
              name: 'calculators',
              displayName: 'Calculators',
            },
          ],
        },
      },
      {
        name: 'topics',
        displayName: 'Topic',
        filtersCollection: {
          items: [
            {
              name: '401k-compliance-and-administration',
              displayName: '401(k) Compliance & Administration',
            },
            {
              name: 'hr-benefits-and-payroll',
              displayName: 'HR, Benefits & Payroll',
            },
            {
              name: 'Retirement Plan Design',
              displayName: 'plan-design',
            },
          ],
        },
      },
    ],
  },
};
